import { useQuery } from '@tanstack/react-query';

import useGameDetails from './useGameDetails.js';

const defaultHouseFee = 5;

function useHouseFee() {
  const gameDetails = useGameDetails();

  const { data: houseFee } = useQuery({
    queryKey: ['houseFee', gameDetails.contracts.prediction?._address, gameDetails.wantedChain.id],
    queryFn: FetchHouseFee,
    placeholderData: defaultHouseFee,
    refetchInterval: 0, // do not refetch
    staleTime: 5 * 60 * 1000,
    cacheTime: 4 * 60 * 60 * 1000,
  });

  async function FetchHouseFee() {
    if (!gameDetails.contracts?.prediction)
      return defaultHouseFee;
    const currentRewardRate = Number(await gameDetails.contracts.prediction.methods.rewardRate().call());
    return (100 - currentRewardRate);
  }

  return houseFee;
};

export default useHouseFee;
